import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  EMessageMatcherButtonColor,
  EMessageMatcherButtonTypes,
  TMessageMatcherButton,
  TVkNotifyContent,
} from 'src/containers/MessageMatchers/definitions';

import * as SS from '../style';
import {FOOTER_TIME} from '../utils';
import * as S from './style';

type TProps = {
  content: TVkNotifyContent;
  children: React.ReactNode;
};

const getButtonColor = (button: TMessageMatcherButton) => {
  if (
    button.buttonType &&
    [EMessageMatcherButtonTypes.LOCATION, EMessageMatcherButtonTypes.VK_MINI_APPS].includes(
      button.buttonType,
    )
  ) {
    return EMessageMatcherButtonColor.PRIMARY;
  }

  return button.color ?? EMessageMatcherButtonColor.SECONDARY;
};

export const VkNotifyContent = React.memo<TProps>(({content, children}) => {
  const {t} = useTranslation();

  const images = content?.vkAttachments ?? [];
  const buttons = content?.buttons ?? [];

  return (
    <SS.Message isInline={!images.length && !buttons.length}>
      <span style={{width: '100%'}}>
        {children}
        {!images.length && (
          <SS.Time>
            <span>{FOOTER_TIME}</span>
          </SS.Time>
        )}
      </span>
      {!!images.length && (
        <S.Gallery>
          {images.map((attachment, index) => (
            <S.Image
              bigFirst={images.length === 1 || images.length === 5}
              key={index}
              src={attachment?.fileUrl}
            />
          ))}
        </S.Gallery>
      )}
      {buttons.map((button, index) => (
        <S.Button key={index} color={getButtonColor(button)}>
          {button.buttonType === EMessageMatcherButtonTypes.URL && <S.ExternalLinkIcon />}
          {button.buttonType === EMessageMatcherButtonTypes.LOCATION ? (
            <>
              <S.LocationIcon />
              <span>{t('MessageMatchers:vkNotify.buttonLocation')}</span>
            </>
          ) : (
            button.text
          )}
        </S.Button>
      ))}
    </SS.Message>
  );
});

VkNotifyContent.displayName = 'VkNotifyContent';
